export default __webpack_public_path__ + "static/flag-it-c5013e882550e75c819b48495df09a41.svg";